export default __webpack_public_path__ + "static/media/os6.29bfaf33.png";